(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-dark-category-landing"] && !Shopify.designMode) return;
  try {
    
async function rotateLandingArtwork(gallery){
  if(gallery.dataset.busy)return;
  const templates=[...gallery.querySelectorAll('template[data-landing-artwork]')],active=gallery.querySelector('[data-landing-active]'),button=gallery.querySelector('[data-landing-next]');
  if(templates.length<2||!active)return;
  const category=gallery.closest('[data-category-landing]').dataset.category,key='rpp-landing-preview-v1-'+category;
  let previous=gallery.dataset.selected;
  if(!previous){try{previous=localStorage.getItem(key)||localStorage.getItem('rpp-category-preview-v1-category_'+category);}catch{}}
  const candidates=templates.filter(t=>t.dataset.landingArtwork!==previous),chosen=candidates[Math.floor(Math.random()*candidates.length)];
  if(!chosen)return;
  const fragment=document.importNode(chosen.content,true),image=fragment.querySelector('img');
  gallery.dataset.busy='true';button.disabled=true;image.loading='eager';image.src=image.getAttribute('src');
  try{await image.decode();active.replaceChildren(fragment);gallery.dataset.selected=chosen.dataset.landingArtwork;try{localStorage.setItem(key,chosen.dataset.landingArtwork);}catch{}}catch{}finally{delete gallery.dataset.busy;button.disabled=false;}
}
function setupCategoryLandings(){document.querySelectorAll('[data-category-landing]').forEach(page=>{
  if(page.dataset.ready)return;page.dataset.ready='true';
  const input=page.querySelector('[data-landing-filter]'),links=[...page.querySelectorAll('[data-landing-link]')],empty=page.querySelector('[data-landing-empty]');
  page.querySelector('[data-landing-filter-wrap]').hidden=false;
  const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  input.addEventListener('input',()=>{const query=normalize(input.value.trim());let visible=0;links.forEach(link=>{link.hidden=!normalize(link.textContent).includes(query);if(!link.hidden)visible++;});empty.hidden=visible>0;});
  const gallery=page.querySelector('[data-landing-gallery]');
  if(gallery.querySelectorAll('template[data-landing-artwork]').length>1){gallery.querySelector('[data-landing-controls]').hidden=false;gallery.querySelector('[data-landing-next]').addEventListener('click',()=>rotateLandingArtwork(gallery));rotateLandingArtwork(gallery);}
});}
setupCategoryLandings();document.addEventListener('shopify:section:load',setupCategoryLandings);window.addEventListener('pageshow',event=>{if(event.persisted)document.querySelectorAll('[data-landing-gallery]').forEach(rotateLandingArtwork);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-dark-header"] && !Shopify.designMode) return;
  try {
    
function setupGalleryNavigation(){document.querySelectorAll('.ad-nav').forEach(nav=>{if(nav.dataset.ready)return;nav.dataset.ready='true';const items=[...nav.querySelectorAll('details')];items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open){items.forEach(other=>{if(other!==item)other.open=false;});if(item.classList.contains('ad-search'))item.querySelector('input[type=search]').focus();}}));nav.addEventListener('keydown',event=>{if(event.key==='Escape'){const item=event.target.closest('details');if(item){item.open=false;item.querySelector('summary').focus();}}});document.addEventListener('click',event=>{if(!nav.contains(event.target))items.forEach(item=>item.open=false);});});}setupGalleryNavigation();document.addEventListener('shopify:section:load',setupGalleryNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-dark-home"] && !Shopify.designMode) return;
  try {
    
function rotateCategoryPreview(card){
  const templates=[...card.querySelectorAll('template[data-category-artwork]')],active=card.querySelector('[data-category-active]');
  if(templates.length<2||!active)return;
  const key='rpp-category-preview-v1-'+card.dataset.categoryKey;
  let previous=card.dataset.previewId;
  if(!previous){try{previous=localStorage.getItem(key);}catch{try{previous=sessionStorage.getItem(key);}catch{}}}
  const choices=templates.filter(template=>template.dataset.categoryArtwork!==previous);
  const chosen=choices[Math.floor(Math.random()*choices.length)];
  if(!chosen)return;
  active.replaceChildren(document.importNode(chosen.content,true));
  card.dataset.previewId=chosen.dataset.categoryArtwork;
  try{localStorage.setItem(key,card.dataset.previewId);}catch{try{sessionStorage.setItem(key,card.dataset.previewId);}catch{}}
}
function setupCategoryPreviews(){document.querySelectorAll('[data-category-preview]').forEach(card=>{if(card.dataset.categoryReady)return;card.dataset.categoryReady='true';rotateCategoryPreview(card);});}
setupCategoryPreviews();
document.addEventListener('shopify:section:load',setupCategoryPreviews);
window.addEventListener('pageshow',event=>{if(event.persisted)document.querySelectorAll('[data-category-preview]').forEach(rotateCategoryPreview);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-dark-index"] && !Shopify.designMode) return;
  try {
    
function setupCollectionIndex(){
  document.querySelectorAll('[data-collection-index]').forEach(index=>{
    if(index.dataset.ready)return;
    index.dataset.ready='true';
    const input=index.querySelector('[data-index-filter]'),groups=[...index.querySelectorAll('[data-index-group]')],empty=index.querySelector('[data-index-empty]'),mobile=window.matchMedia('(max-width:760px)');
    const normalize=value=>value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    let openGroup=null;
    function updatePanels(){
      index.toggleAttribute('data-mobile-accordion',mobile.matches);
      groups.forEach(group=>{
        const expanded=mobile.matches&&group===openGroup,button=group.querySelector('[data-index-toggle]');
        button.setAttribute('aria-expanded',String(expanded));
        button.querySelector('.ad-index-toggle-icon').textContent=expanded?'−':'+';
        group.querySelector('[data-index-panel]').hidden=mobile.matches&&!expanded;
      });
    }
    function filter(){
      const query=mobile.matches?'':normalize(input.value.trim());
      let total=0;
      groups.forEach(group=>{
        let visible=0;
        group.querySelectorAll('[data-index-item]').forEach(item=>{
          const matches=normalize(item.textContent).includes(query);item.hidden=!matches;if(matches)visible++;
        });
        group.hidden=visible===0;total+=visible;
      });
      empty.hidden=total>0;
    }
    function revealHash(){
      const target=groups.find(group=>'#'+group.id===window.location.hash);
      if(mobile.matches&&target){openGroup=target;updatePanels();}
    }
    groups.forEach(group=>{
      group.querySelector('[data-index-toggle]').addEventListener('click',()=>{
        if(!mobile.matches)return;openGroup=openGroup===group?null:group;updatePanels();
      });
      group.addEventListener('keydown',event=>{
        if(event.key==='Escape'&&mobile.matches&&openGroup===group){openGroup=null;updatePanels();group.querySelector('[data-index-toggle]').focus();}
      });
    });
    input.addEventListener('input',filter);
    mobile.addEventListener('change',()=>{updatePanels();filter();revealHash();});
    window.addEventListener('hashchange',revealHash);
    updatePanels();filter();revealHash();
  });
}
setupCollectionIndex();document.addEventListener('shopify:section:load',setupCollectionIndex);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class LoadMedia extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const deferredMediaBtn = this.closest('.video-section').querySelector('.js-load-media');
      button.addEventListener('click', () => deferredMediaBtn.click());
    }
  }
  customElements.define('load-media', LoadMedia);

  } catch(e) { console.error(e); }
})();
})();
